/* eslint-disable camelcase */
import PageActionCreators from 'actions/framework/PageActionCreators';
import sdnApi from 'services/api/sdn';
import addressUtils from 'utils/Address';
import urlUtils from 'utils/Url';
import catalogUtils from 'utils/Catalog';
import ConstructorRecsUtils from 'utils/ConstructorRecs';
import decorators from 'utils/decorators';
import sysUtils from 'utils/ShopYourStore';
import ConstructorRecsActions from 'actions/ConstructorRecsActions';
import Empty from 'constants/empty';
import { SET_NEW_PRODUCTS_PAGE, SET_BESTSELLER_PRODUCTS_PAGE } from 'constants/actionTypes/storeAggregation';
import { RESULTS_COUNT } from 'constants/constructorConstants';

const { transformConstructorResponseForCarousel } = ConstructorRecsUtils;
const { updateConstructorRecommendations, setLoading } = ConstructorRecsActions;

class StoreAggregationActionCreators extends PageActionCreators {
    isNewPage = () => true;

    updatePage = () => ({});

    openPage = () => ({});

    setNewProductsPage = payload => {
        return {
            type: SET_NEW_PRODUCTS_PAGE,
            payload
        };
    };

    setBestsellerProductsPage = payload => {
        return {
            type: SET_BESTSELLER_PRODUCTS_PAGE,
            payload
        };
    };

    fetchNewProducts = (podId, currentPage = 1, pageSize = RESULTS_COUNT.CONTENT_PAGE_SIZE, showLoading = false) => {
        return async (dispatch, getState) => {
            try {
                if (!showLoading) {
                    dispatch(setLoading({ podId }));
                }

                const { user } = getState();
                const storeId = user?.preferredStore;
                const zipCode = addressUtils.formatZipCode(user?.preferredZipCode);
                const ref = urlUtils.getParams()?.ref || [];

                const payload = {
                    podId,
                    storeId,
                    zipCode,
                    currentPage,
                    pageSize,
                    ref
                };

                const contextId = catalogUtils.createContextId();
                const response = !showLoading
                    ? await sdnApi.getNewProducts(payload)
                    : await decorators.withInterstice(sdnApi.getNewProducts)(payload);

                const eligibilityFlags = response?.data?.eligibilityFlags || Empty.Object;
                const constructorData = response?.data?.constructor || Empty.Object;
                const { collection, results, total_num_results } = constructorData?.response;

                if (results) {
                    let items = transformConstructorResponseForCarousel(results);
                    items = sysUtils.mergeElegibilityFlags(items, eligibilityFlags);

                    dispatch(
                        updateConstructorRecommendations({
                            podId: collection.id,
                            constructorTitle: collection.display_name,
                            constructorRecommendations: items,
                            totalResults: total_num_results,
                            resultId: constructorData.result_id
                        })
                    );
                    dispatch(
                        this.setNewProductsPage({
                            contextId,
                            items,
                            currentPage,
                            ...(response?.data || Empty.Object)
                        })
                    );
                } else {
                    dispatch(
                        updateConstructorRecommendations({
                            podId: collection.id,
                            constructorTitle: collection.display_name,
                            constructorRecommendations: [],
                            isEmpty: true
                        })
                    );
                }

                dispatch(setLoading({ podId, isLoading: false }));
            } catch (_error) {
                dispatch(updateConstructorRecommendations({ podId, constructorRecommendations: [], isError: true }));
                dispatch(setLoading({ podId, isLoading: false }));
            }
        };
    };

    fetchBestsellersProducts = (podId, currentPage = 1, pageSize = RESULTS_COUNT.CONTENT_PAGE_SIZE, showLoading = false) => {
        return async (dispatch, getState) => {
            try {
                if (!showLoading) {
                    dispatch(setLoading({ podId }));
                }

                const { user } = getState();
                const storeId = user?.preferredStore;
                const zipCode = addressUtils.formatZipCode(user?.preferredZipCode);
                const ref = urlUtils.getParams()?.ref || [];

                const payload = {
                    podId,
                    storeId,
                    zipCode,
                    currentPage,
                    pageSize,
                    ref
                };

                const contextId = catalogUtils.createContextId();
                const response = !showLoading
                    ? await sdnApi.getBestsellersProducts(payload)
                    : await decorators.withInterstice(sdnApi.getBestsellersProducts)(payload);

                const eligibilityFlags = response?.data?.eligibilityFlags || Empty.Object;
                const constructorData = response?.data?.constructor || Empty.Object;
                const { pod, results, total_num_results } = constructorData?.response;

                if (results) {
                    let items = transformConstructorResponseForCarousel(results);
                    items = sysUtils.mergeElegibilityFlags(items, eligibilityFlags);

                    dispatch(
                        updateConstructorRecommendations({
                            podId,
                            constructorTitle: pod.display_name,
                            constructorRecommendations: items,
                            totalResults: total_num_results,
                            resultId: constructorData.result_id
                        })
                    );

                    dispatch(
                        this.setBestsellerProductsPage({
                            contextId,
                            items,
                            currentPage,
                            ...(response?.data || Empty.Object)
                        })
                    );
                } else {
                    dispatch(
                        updateConstructorRecommendations({
                            podId,
                            constructorTitle: pod.display_name,
                            constructorRecommendations: [],
                            isEmpty: true
                        })
                    );
                }

                dispatch(setLoading({ podId, isLoading: false }));
            } catch (_error) {
                dispatch(updateConstructorRecommendations({ podId, constructorRecommendations: [], isError: true }));
                dispatch(setLoading({ podId, isLoading: false }));
            }
        };
    };
}

const StoreAggregationActions = new StoreAggregationActionCreators();

export default StoreAggregationActions;
